<div class="login-register" style="background-image:url(assets/images/background/login-register.jpg);">
<router-outlet></router-outlet>
    <app-footer></app-footer>

</div>
